<template>
  <div v-if="files.length" class="file-list">
    <div class="file-list__header">
      <span>已选择 {{ files.length }} 个文件</span>
      <button class="btn btn-ghost" @click="$emit('clear')">清空</button>
    </div>
    <ul class="file-list__items">
      <li v-for="f in files" :key="f.id" class="file-item">
        <div class="file-item__thumb">
          <img v-if="f.preview" :src="f.preview" :alt="f.name" />
        </div>
        <div class="file-item__main">
          <div class="file-item__name" :title="f.name">{{ f.name }}</div>
          <div class="file-item__meta">
            <span>{{ formatBytes(f.size) }}</span>
            <span v-if="f.width && f.height" class="file-item__dims">{{ f.width }} × {{ f.height }}</span>
            <span v-if="f.status === 'converting'" class="file-item__status file-item__status--busy">转换中…</span>
            <span v-else-if="f.status === 'done'" class="file-item__status file-item__status--ok">已完成</span>
            <span v-else-if="f.status === 'error'" class="file-item__status file-item__status--err">{{ f.error || '失败' }}</span>
          </div>
        </div>
        <button
          v-if="f.status !== 'converting'"
          class="btn btn-danger-ghost file-item__remove"
          @click="$emit('remove', f.id)"
          title="移除"
        >
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { formatBytes } from '../utils/pngToIco.js';

export default {
  name: 'FileList',
  props: {
    files: { type: Array, required: true },
  },
  emits: ['remove', 'clear'],
  methods: {
    formatBytes,
  },
};
</script>

<style lang="less" scoped>
.file-list {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    color: var(--text-dim);
    margin-bottom: 10px;
  }

  &__items {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
  }
}

.file-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  min-width: 220px;
  max-width: 320px;
  flex: 1 1 220px;
  background: var(--bg-elev-2);
  border: 1px solid var(--border);
  border-radius: 6px;

  &__thumb {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  &__main {
    flex: 1;
    min-width: 0;
  }

  &__name {
    font-size: 14px;
    color: var(--text);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__meta {
    margin-top: 2px;
    font-size: 12px;
    color: var(--text-dim);
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  &__dims {
    color: var(--text-dim);
  }

  &__status {
    font-size: 12px;
    padding: 1px 8px;
    border-radius: 999px;
    line-height: 1.4;

    &--busy {
      background: rgba(255, 122, 26, 0.15);
      color: var(--accent);
    }
    &--ok {
      background: rgba(82, 196, 26, 0.15);
      color: var(--success);
    }
    &--err {
      background: rgba(255, 77, 79, 0.15);
      color: var(--error);
    }
  }

  &__remove {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    display: inline-flex;
  }
}
</style>
